import { Button, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Radio, RadioGroup, TextField, Typography, Tooltip, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import MultipleMetadataFields from '../../../components/TemplatesForms/Selector/MultipleMetadataFields';
import RenderForm from '../../../components/TemplatesForms/RenderForm';
import { IMetadataJSON } from '../../../components/TemplatesForms/Selector/types';
import { useLocation, useNavigate } from 'react-router-dom';
import { PreviewFormIncomingProps } from './NewFormPreview';
import TitleLayout from '../../../components/layout/TitleLayout';
import { AutoCompleteInputOption } from '../../../components/Inputs/AutocompleteFreeSolo';
import AutocompleteInput from '../../../components/Inputs/AutocompleteInput';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import { Box } from '@mui/system';
import Theme from '../../../Themes/main.theme';
import TermsDialog from '../../../components/Dialog/TermsDialog';
import InfoIcon from '@mui/icons-material/Info';

interface FormNewRequestProps {
  organicUnits: { label: string, value: string }[];
  tomeas: { label: string, value: string }[];
  glossa: { label: string, value: string }[];
  isLoading: boolean;
}
function FormNewRequest(props: FormNewRequestProps) {
  const { organicUnits = [{ label: 'string', value: 'string' }], tomeas = [{ label: 'string', value: 'string' }],
    glossa = [{ label: 'string', value: 'string' }] } = props;

  const [formFields, setFormFields] = React.useState<IMetadataJSON[]>([]);
  const [formTitle, setFormTitle] = React.useState<string>('');
  const [selectedOrganicUnit, setSelectedOrganicUnit] =
    React.useState<AutoCompleteInputOption | null>(null);
  const [selectedTomeas, setSelectedTomeas] =
    React.useState<AutoCompleteInputOption | null>(null);
  const [selectedFormType, setSelectedFormType] = React.useState<string>('');
  const [formDescription, setFormDescription] = React.useState<string>('');
  const [checkboxes, setCheckboxes] = React.useState({ acceptPolicy: false });
  const [termsOpen, setTermsOpen] = React.useState<boolean>(false);
  const [checked, setChecked] = React.useState(false);
  const [emailForProtok, setEmailForProtok] = React.useState<string>('');
  const [emailSubjectForProtocol, setEmailSubjectForProtocol] = React.useState<string>('');
  const [formLanguage, setFormLanguage] = React.useState<AutoCompleteInputOption | null>(null);
  const isValidEmail = (email: string) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  const submitIsDisabled = !formTitle
    || (selectedOrganicUnit && !Object?.keys(selectedOrganicUnit)?.length)
    || (selectedTomeas && !Object?.keys(selectedTomeas)?.length)
    || !selectedTomeas
    || !checked
    || !formFields.length
    || (formLanguage && !Object?.keys(formLanguage)?.length)
    || !selectedFormType
    || !formDescription
    || (selectedFormType == String(4) ?
      (!emailForProtok && isValidEmail(emailForProtok))
      || !emailSubjectForProtocol
      : false);

  const handleOrganicUnitChange = (_: any, newValue: any) => {
    setSelectedOrganicUnit(newValue);
  };

  const handleFormTypeChange = (event: any) => {
    setSelectedFormType(event.target.value);
  };

  const handleTomeasChange = (_: any, newValue: any) => {
    setSelectedTomeas(newValue);
  };

  const handleLanguageCreateForm = (_: any, language: any) => {
    setFormLanguage(language);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const _handleCheckboxChange = (event: any) => {    
    setCheckboxes({ ...checkboxes, [event.target.name]: event.target.checked });
  };

  const handleClickOpen = () => {
    setTermsOpen(true);
  };

  const location: { state: PreviewFormIncomingProps } = useLocation();
  useEffect(() => {
    const { state } = location;
    if (location.state) {
      state.formFields && setFormFields(state.formFields);
      state.formTitle && setFormTitle(state.formTitle);
      state.selectedFormType && setSelectedFormType(state.selectedFormType);
      state.selectedOrganicUnit && setSelectedOrganicUnit(state.selectedOrganicUnit);
      state.selectedTomeas && setSelectedTomeas(state.selectedTomeas);
      state.formLanguage && setFormLanguage(state.formLanguage);
      state.formDescription && setFormDescription(state.formDescription);
      state.checkboxes && setCheckboxes(state.checkboxes);
      state.emailForProtok && setEmailForProtok(state.emailForProtok);
      state.emailSubjectForProtocol && setEmailSubjectForProtocol(state.emailSubjectForProtocol);
    }
  }, []);

  const navigate = useNavigate();
  return (
    <>
      <Typography variant='h2' color={Theme.labelColor?.main}
        sx={{ my: 2, mt: 4 }}>
        Δημιουργία Νέου Αιτήματος / Φόρμα
      </Typography>
      <Divider sx={{ mb: 2, border: 1, color: Theme?.dividerColor?.main }} />
      <FormHelperText>
        <Typography
          variant='body1'
          fontStyle='italic'
          sx={{
            marginTop: '16px',
            fontWeight: 'bolder',
          }}
        >
          {'Πρέπει να συμπληρωθούν όλα τα υποχρεωτικά πεδία και να προσθέσετε τουλάχιστον ένα, ώστε να προχωρήσετε στη προεπισκόπηση του αιτήματός σας.'}
        </Typography>
      </FormHelperText>
      <TitleLayout>
        <Stack flexDirection='row'>
          <Typography variant='h3'>Βασικά Στοιχεία</Typography>
          <Tooltip
            PopperProps={{
              disablePortal: true
            }} title={'Με την επιλογή γλώσσας της φόρμας, μετά την δημιουργία της θα προστεθεί στην αντίστοιχη λίστα, δηλαδή στην λίστα με τις φόρμες που έχουν γραφεί στην ελληνική γλώσσα αν έχετε επιλέξει Ελληνικά και αντίστοιχα στην λίστα με τις αγγλικές φόρμες αν έχετε επιλέξει Αγγλικά.'}
            placement='right-start'>
            <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
          </Tooltip>
        </Stack>

        <AutocompleteInput
          value={formLanguage}
          onChange={handleLanguageCreateForm} optionsList={glossa}
          placeholder='Γλώσσα Φόρμας *' />

        <TextField label='Τίτλος Φόρμας' variant='outlined'
          value={formTitle} onChange={(e) => setFormTitle(e.target.value)} 
          required={true} />

        <TextField
          value={formDescription}
          onChange={(e) => setFormDescription(e.target.value)}
          label='Περιγραφή αιτήματος'
          variant='outlined'
          required={true}
          multiline
          rows={4} />

        <Box display='flex' gap={5}>
          <AutocompleteInput
            value={selectedOrganicUnit}
            onChange={handleOrganicUnitChange} optionsList={organicUnits}
            placeholder='Υπεύθυνη Οργανική Μονάδα *' />
          <AutocompleteInput
            value={selectedTomeas}
            onChange={handleTomeasChange}
            optionsList={tomeas}
            placeholder='Τομέας *' />
        </Box>

        <FormControl>
          <FormLabel id='demo-row-radio-buttons-group-label'>Επιλέξτε Eίδος Aιτήματος *</FormLabel>
          <RadioGroup
            row
            aria-labelledby='demo-row-radio-buttons-group-label'
            name='row-radio-buttons-group'
            onChange={handleFormTypeChange}
            value={selectedFormType}
          >
            <FormControlLabel value='1' control={<Radio />}
              label='Επώνυμη Φόρμα (χωρίς Πρωτοκόλληση ΣΗΔΕ)' />
            <FormControlLabel value='2' control={<Radio />}
              label='Ανώνυμη Φόρμα (χωρίς Πρωτοκόλληση ΣΗΔΕ)' />
            <FormControlLabel
              value='3'
              control={<Radio />}
              label='Επώνυμη Φόρμα με πρωτοκόλληση και διεκπεραίωση υπηρεσιακά στο ΣΗΔΕ'
            />
            <FormControlLabel
              value='4'
              control={<Radio />}
              label='Επώνυμη Φόρμα με πρωτοκόλληση μέσω email'
            />

          </RadioGroup>
        </FormControl>

        {(selectedFormType === '3' || selectedFormType === '4') && <>
          <TextField
            error={isValidEmail(emailForProtok)
              ? false
              : true}
            value={emailForProtok} onChange={(e) => setEmailForProtok(e.target.value)}
            label='Εισάγετε την διεύθυνση email στο οποίο θα σταλεί το αίτημα' variant='outlined' />
          <TextField value={emailSubjectForProtocol}
            onChange={(e) => setEmailSubjectForProtocol(e.target.value)}
            label='Εισάγετε το θέμα στο οποίο θα σταλεί το αίτημα' variant='outlined' />
        </>}

      </TitleLayout>

      <MultipleMetadataFields hideValues
        formFields={formFields}
        setFormFields={setFormFields}
      />

      <TitleLayout >
        <Typography variant='h3'>Προεπισκόπηση</Typography>

        <RenderForm setMetadataArray={setFormFields} metadataArray={formFields} />
        {checkboxes.acceptPolicy && <Box>
          <FormControlLabel 
            control={
              <Checkbox 
                checked={checked}
                onChange={handleCheckboxChange}/>
            }
            label={
              <>
                <Button onClick={handleClickOpen}>Αποδοχή όρων Χρήσης & Ορθότητας Στοιχείων</Button>
                <TermsDialog open={termsOpen} handleClose={() => setTermsOpen(false)}
                  onAccept={() => {
                    setTermsOpen(false);
                    setChecked(true);
                  }}
                  onDecline={()=> setChecked(false)}/>
              </>
            }/>
        </Box>}
      </TitleLayout>


      <Typography variant='h3'>Εισαγωγή Υποχρεωτικών Checkboxes</Typography>
      <FormGroup>
        <FormControlLabel
          checked={checkboxes.acceptPolicy}
          onChange={_handleCheckboxChange}
          name='acceptPolicy'
          control={<Checkbox/>}
          label='Εισαγωγή Πεδίου Αποδοχής Χρήσης και Πολιτικης' />
      </FormGroup>


      <FormActionButtonLayout >
        <Button disabled={submitIsDisabled} onClick={() => navigate('/admin/applications/preview', {
          state: {
            formFields,
            formTitle,
            selectedOrganicUnit,
            selectedTomeas,
            formLanguage,
            selectedFormType,
            formDescription,
            checkboxes,
            emailForProtok,
            checked,
            emailSubjectForProtocol
          }
        })}
        variant='contained'
        color='primary'>Προεπισκόπηση Αιτήματος/Φόρμας</Button>
      </FormActionButtonLayout>
    </>
  );
}

export default FormNewRequest;